var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 57,
    viewBox: "0 0 51 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.3C0 4.62914 0.663748 3.02671 1.84523 1.84523C3.02671 0.663748 4.62914 0 6.3 0H30.1959C31.8666 0.000356816 33.4688 0.664339 34.65 1.8459L48.5541 15.75C49.7357 16.9312 50.3996 18.5334 50.4 20.2041V50.4C50.4 52.0709 49.7362 53.6733 48.5548 54.8548C47.3733 56.0363 45.7709 56.7 44.1 56.7H6.3C4.62914 56.7 3.02671 56.0363 1.84523 54.8548C0.663748 53.6733 0 52.0709 0 50.4V6.3ZM30.1959 6.3H6.3V30.2778L13.734 22.9541L15.8445 20.8814L18.0495 22.8533L24.9826 29.0588L31.0716 22.973L33.1884 20.8561L35.4123 22.8627L44.1 30.7094V20.2041L30.1959 6.3ZM44.1 39.1986L33.412 29.5438L29.6856 33.2703L44.1 46.1727V39.1986ZM6.3 50.4V39.1199L16.0492 29.5187L39.3782 50.4H6.3Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFile);
export default __webpack_public_path__ + "static/media/document-file.c5d48d2b3a28d20af1699d3a89c89299.svg";
export { ForwardRef as ReactComponent };